import { FC, useMemo } from 'react'
import { useTranslation } from 'next-i18next'
import { UseFormRegister, UseFormGetValues, FieldErrors } from 'react-hook-form'
import { WishlistManager } from '@corratech/pylot-wishlist/src/Hooks/WishlistActionTypes'
import { NoWishlistItems } from '@corratech/pylot-wishlist/src/WishlistItems'
import { WishlistDetails } from './WishlistDetails'
import { WishlistProductGrid } from '../WishlistItems/WishlistProductGrid'

import {
    CopyWishlist,
    MoveWishlist
} from '@corratech/pylot-wishlist/src/WishlistToolbar'

import { DeleteWishlistItem } from '@components/alfakher/pylot-wishlist/src/WishlistToolbar/DeleteWishlistItem/DeleteWishlistItem'

import {
    Wishlist,
    WishlistItemInterface,
    ConfigurableWishlistItem,
    WishlistItemUpdateInput
} from '@pylot-data/pylotschema'
import s from '@pagestyles/Wishlist.module.scss'
import cn from 'classnames'

export type wishlist = {
    wishlist: Wishlist
    wishlistManager: WishlistManager
    register: UseFormRegister<Array<WishlistItemUpdateInput>>
    getValues?: UseFormGetValues<Array<WishlistItemUpdateInput>>
    errors: FieldErrors<Array<WishlistItemUpdateInput>>
}

export const WishlistItems: FC<wishlist> = ({
    wishlist,
    wishlistManager,
    register,
    getValues,
    errors
}) => {
    const { t } = useTranslation(['wishlist'])

    const items = useMemo(() => {
        return wishlist?.items_v2?.items?.map((item, key) => (
            <div className={s['wishlist-product-grid']} key={key}>
                <WishlistProductGrid
                    item={
                        item as WishlistItemInterface & ConfigurableWishlistItem
                    }
                    wishlistManager={wishlistManager}
                />
                <div
                    className={cn(
                        s['wishlist-hidden-wrapper'],
                        'wishlist-hidden-wrapper'
                    )}
                >
                    <WishlistDetails
                        index={key}
                        getValues={getValues!}
                        register={register}
                        errors={errors}
                        wishlist={wishlist}
                        item={
                            item as WishlistItemInterface &
                                ConfigurableWishlistItem
                        }
                    />
                    <div className={s['wishlist-hidden-mobile']}>
                        <CopyWishlist
                            item={item}
                            wishlist={wishlist}
                            dropDownLabel={t('wishlist|Copy to Wish List')}
                        />
                        <MoveWishlist
                            item={item}
                            wishlist={wishlist}
                            dropDownLabel={t('wishlist|Move to Wish List')}
                        />
                        <DeleteWishlistItem item={item} wishlist={wishlist} />
                    </div>
                </div>
            </div>
        ))
    }, [wishlist, wishlistManager])

    if (!wishlist?.items_v2?.items?.length) {
        return <NoWishlistItems />
    }

    return (
        <form>
            <div className={s['wishlist-items-container']}>{items}</div>
        </form>
    )
}
